export const getJsonFromArraybuffer = response => {
  let res;
  try {
    res = JSON.parse(new TextDecoder().decode(response.data));
  } catch (e) {
    res = {};
  }
  return res;
};

export const handleDataValidationErrors = (response) => {
  const errorObj = {};
  if (response?.data?.errors) {
    const errors = response?.data?.errors;
    if (errors.chartValue?.length) {
      errors.chartValue.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].chartValue = true;
      });
    }
    if (errors.barcode39?.length) {
      errors.barcode39.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].barcode39 = true;
      });
    }
    if (errors.mandatory?.length) {
      errors.mandatory.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].mandatory = true;
      });
    }
    if (errors.length?.length) {
      errors.length.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].length = true;
      });
    }
    if (errors.dateFormat?.length) {
      errors.dateFormat.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].dateFormat = true;
      });
    }
    if (errors.empty?.length) {
      errors.empty.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].empty = true;
      });
    }
    if (errors.invalidHtml?.length) {
      errors.invalidHtml.forEach(value => {
        if (!errorObj[value]) {
          errorObj[value] = {};
        }
        errorObj[value].invalidHtml = true;
      });
    }
  }
  return errorObj;
};
